import React from "react";
import { Link } from 'react-router-dom';


const OTP = ({clicked}) => {
 
  return (
    <div className="col-lg-6 col-md-12 col-md-justify-content-center d-flex align-self-center">
      <div className="row w-100 px-4 responsive-center">
        <div className="col-lg-12 col-md-12">
          <p className="h3desc">We have sent you an OTP on</p>
          <p className="h2desc font-weight-bold">+880 123 4567</p>
          <p className="h2desc ">Enter Your 6-digit OTP:</p>
          <div className="form_input">
            <input className="form-control py-2 h-auto" placeholder="Please Enter the OTP here to verify" type="text" id="otp" required />
            <label className="ml-3" htmlFor="opt">
              OTP </label>
          </div>

          <div className="h4desc">
            <span> Still not received OTP? <Link to="/" style={{ color: "#25BCA7" }}> Get via call</Link></span>
            <span className="float-right" style={{ color: "#25BCA7" }}>Resend OTP</span> </div>
        </div>
        <br />
        <button onClick={clicked} className="w-100 w-md-50 mx-3 my-4 active tableButton">CONTINUE BOOKING</button>
      </div>
    </div>


  );
};

export default OTP;

